var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{class:`dtt-icon dtt-icon-${_vm.name}`,style:(_vm.wrapperStyles)},[(_vm.name)?_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":_vm.viewBox}},[_c(_vm.componentName,{tag:"component"})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }